import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import LandingPage from '@/pages/LandingPage';

/**
 * HomeRoute handles the `/` route:
 * - Unauthenticated users see the public LandingPage
 * - Authenticated users are redirected to `/dashboard` which lives inside
 *   AuthenticatedRoutesLayout and inherits all providers (entitlement,
 *   realtime, subscription gate, etc.)
 */
const HomeRoute = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full"></div>
      </div>
    );
  }

  if (!user) {
    return <LandingPage />;
  }

  // Authenticated — redirect to dashboard inside AuthenticatedRoutesLayout
  return <Navigate to="/dashboard" replace />;
};

export default HomeRoute;
